<mat-toolbar
  class="toolbar"
  [ngClass]="{ sticky: isDesktop }"
  [style.background-color]="backgroundColor"
>
  <div class="jsg-action-bar">
    <div class="jsg-left-bar" fxLayout="row" fxLayoutAlign="start center">
      <ng-content select="[left-bar]"></ng-content>
    </div>
    <div class="jsg-middle-bar">
      <ng-content select="[middle-bar]"></ng-content>
    </div>
    <div class="jsg-right-bar">
      <ng-content select="[right-bar]"></ng-content>
    </div>

    <ng-content select="[end-bar]"></ng-content>
  </div>
</mat-toolbar>
